import { render, staticRenderFns } from "./GroupsFilterByNotificacion.vue?vue&type=template&id=7d4dbcab&scoped=true&"
import script from "./GroupsFilterByNotificacion.vue?vue&type=script&lang=js&"
export * from "./GroupsFilterByNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4dbcab",
  null
  
)

export default component.exports